/**
 * Предупреждения patch engine → тексты для пользователя.
 *
 * Наружу выводятся только те коды, которые меняют смысл запроса и которые
 * пользователь может исправить. Технические причины отброшенных операций
 * (`PATCH_VALUE_INVALID`, `PATCH_LOW_CONFIDENCE` и т. п.) остаются в payload
 * для диагностики, но в интерфейсе не показываются: пользователю нечего с
 * ними делать.
 */

const USER_FACING: Readonly<Record<string, string>> = {
  EMPHASIS_CAPPED: 'criteria.warning.emphasisCapped',
  PRIORITIES_TRUNCATED: 'criteria.warning.prioritiesTruncated',
  MANUAL_EMPHASIS_ONLY_RESET: 'criteria.warning.manualEmphasis',
  // Обязательная марка вытеснила список предпочтительных: других марок в
  // выдаче всё равно не будет (MATCHING §3.2, BE-392).
  MAKES_PREFERRED_DROPPED: 'criteria.warning.makesPreferredDropped',
  // «Сделайте надёжность обязательной»: у критерия нет поля объявления, и он
  // стал акцентом, а не фильтром. Об этом говорится прямо (MATCHING §3.5).
  HARDNESS_NOT_APPLICABLE: 'criteria.warning.hardnessNotApplicable',
  // Вопрос задан дважды и остался без ответа: Karl принял «без ограничения»
  // (KARL_DIALOG_RFC §4.8). Решение за пользователя, сделанное молча, было бы
  // хуже самого дефолта — поэтому оно видно и поправимо.
  SLOT_DEFAULTED: 'criteria.warning.slotDefaulted',
  // Уточняющий вопрос («только эта модель или похожие тоже?») задан дважды и
  // остался без ответа: Karl закрыл его в мягкую сторону — условие стало
  // пожеланием, а не требованием (KARL_DIALOG_RFC §4.5). Это решение за
  // пользователя, и оно обязано быть видно так же, как `SLOT_DEFAULTED`.
  HARDNESS_DEFAULTED_SOFT: 'criteria.warning.hardnessDefaultedSoft',
};

export function criteriaWarningKey(code: string): string | null {
  return USER_FACING[code] ?? null;
}
